import { render } from "./GraphPie.vue?vue&type=template&id=471fb830&scoped=true"
import script from "./GraphPie.vue?vue&type=script&lang=js"
export * from "./GraphPie.vue?vue&type=script&lang=js"

import "./GraphPie.vue?vue&type=style&index=0&id=471fb830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471fb830"]])

export default __exports__